module.exports = __webpack_public_path__ + "static/img/16.d178563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/16.png
// module id = LKKP
// module chunks = 0